// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".two-dimensional-image .two-dimensional-image__add-button small{padding-left:5px}.two-dimensional-image .two-dimensional-image__image-canvas-container{background:#f6f6f6}.two-dimensional-image .two-dimensional-image__label-button{color:#000}.two-dimensional-image .two-dimensional-image__label-button:hover,.two-dimensional-image .two-dimensional-image__label-button:active,.two-dimensional-image .two-dimensional-image__label-button:focus{text-decoration:none}\n", ""]);
// Exports
module.exports = exports;
